import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

import {AppModule} from './app/app.module';
import {environment} from './environments/environment';
import {Logger} from './app/shared/utils/logger';


if (environment.production) {
    enableProdMode();
}

Logger.overrideConsoleLog();

platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.log(err));
